import {Avatar} from 'antd'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {BsCaretDownFill, BsCaretUpFill} from 'react-icons/bs'
import {NullAsDefault, pagerControls, renderSelf} from 'views/Shared'
import EntityList from '../../../EntityList'
import {bindQueryParam} from '../../../functions/routerHelper'
import {renderIf} from "../../../../Shared";
import {timetable_getTeacherSubjectsOfCourseClass_Api} from "../../../../../apis";
import {ListHeaderWithLine} from "../../../Templates/items/ListHeader";
import {renderCourseClassTeacherItem} from "../../CourseClass/CourseClassTeachers";
import Toggle from "../../../../../components/Toggle";
import {ActionModalWrapper} from "../../../../../components/form/ActionModalWrapper";


export const CourseTeachers = ({
                                 item,
                                 header = null,
                                 controls = pagerControls,
                                 renderFooter = renderSelf,
                               }) => {
  const t = useTranslate();
  const apiInfo = timetable_getTeacherSubjectsOfCourseClass_Api


  return (
    <ActionModalWrapper className="flex-1 p-3">
      {header}
      <div className="flex flex-col gap-3 flex-1">
          <span className="font-bold text-sm text-color-400 uppercase tracking-wide">
              {t('list of teachers')}
          </span>
        <div className="flex flex-col gap-6">
          {_.get(item, 'course_classes', []).map((e, i) => {
            return (
              <Toggle>
                {(isToggle, toggle) => (
                  <React.Fragment key={i}>
                    <EntityList
                      apiInfo={apiInfo}
                      RenderEntity={React.Fragment}
                      query={bindQueryParam({id: e?.id})}
                      renderItem={renderCourseClassTeacherItem({
                        detail: true,
                        NullAsDefault,
                      })}
                      renderWrap={(child, __, count) =>
                        renderIf(
                          count,
                          <div className="w-full flex flex-col flex-1 gap-3">
                            <ListHeaderWithLine
                              title={e?.title}
                              className="text-xs"
                              extra={
                                <Avatar
                                  onClick={toggle}
                                  size={22}
                                  className="flex flex-center bg-primary-50 hover:bg-primary-100 rounded-md cursor-pointer"
                                  icon={
                                    !isToggle ?
                                      <BsCaretUpFill size={12} className="text-primary"/> :
                                      <BsCaretDownFill size={12} className="text-primary"/>
                                  }
                                />
                              }
                            />
                            {!isToggle && (
                              <div className="flex flex-col gap-3">{child}</div>
                            )}
                          </div>
                        )
                      }
                    />
                  </React.Fragment>
                )}
              </Toggle>
            )
          })}
        </div>
      </div>
      {renderFooter(null)}
    </ActionModalWrapper>
  )
}
